import { render, staticRenderFns } from "./AdminCreateUser.vue?vue&type=template&id=4b795058&scoped=true"
import script from "./AdminCreateUser.vue?vue&type=script&lang=js"
export * from "./AdminCreateUser.vue?vue&type=script&lang=js"
import style0 from "./AdminCreateUser.vue?vue&type=style&index=0&id=4b795058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b795058",
  null
  
)

export default component.exports